import Vue from 'vue'
import App from './App.vue'
import './styles/index.scss'
import './plugins/element'

document.title = '系统登录'

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
